"use strict";
function r(e, a) {
  return a ? e.replace(/\/?\/$/, "") + "/" + a.replace(/^\/+/, "") : e;
}
export {
  r as default
};
//# sourceMappingURL=index.es351.js.map
